import dayjs from "dayjs";
import { toast } from "react-toastify";
import APICall, { explodeDataWithRowTable } from "../components/Api/APICall";
const CommanApiGETFunction = async (url, setOutputList, explodeData = true) => {
  await APICall(url, "GET")
    .then((data) => {
      if (data.status) {
        if (explodeData) {
          explodeDataWithRowTable(data.message, setOutputList);
        } else {
          if (data.message.length > 0) {
            setOutputList(data.message);
          } else {
            setOutputList([]);
          }
          // toast.error("Data Not  found")
        }
      } else {
        toast.error(data.message);
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

const TableCellAmountFormate = (cell, color, isAmount = true) => {
  if (isAmount) {
    return <b className={color}>{cell.value.toFixed(2)}</b>;
  } else {
    return <b className={color}>{cell.value}</b>;
  }
};
const GetSatartAndEndDate = (type) => {
  const data = {
    startDate: dayjs().format("YYYY-MM-DD"),
    endDate: dayjs().format("YYYY-MM-DD"),
  };
  switch (type) {
    case "yesterday":
      const thisWeek = dayjs().add(-1, "day");
      data.startDate = dayjs(thisWeek).format("YYYY-MM-DD");
      data.endDate = dayjs(thisWeek).format("YYYY-MM-DD");

      break;
    case "ThisWeek":
      const yesterDay = dayjs().startOf("week");
      data.startDate = dayjs(yesterDay).format("YYYY-MM-DD");
      data.endDate = dayjs(yesterDay).endOf("week").format("YYYY-MM-DD");

      break;
    case "LastWeek":
      const lastWeek = dayjs().startOf("week");
      data.startDate = dayjs(lastWeek).add(-7, "day").format("YYYY-MM-DD");
      data.endDate = dayjs(lastWeek).add(-1, "day").format("YYYY-MM-DD");

      break;
    case "ThisMonth":
      const thisMonth = dayjs().startOf("month");
      data.startDate = dayjs(thisMonth).format("YYYY-MM-DD");
      data.endDate = dayjs(thisMonth).endOf("month").format("YYYY-MM-DD");
      break;
    case "LastMonth":
      const lastMonth = dayjs().startOf("month");
      data.startDate = dayjs(lastMonth).add(-1, "month").format("YYYY-MM-DD");
      data.endDate = dayjs(lastMonth).add(-1, "day").format("YYYY-MM-DD");
      break;
    case "ThisYear":
      const thisYear = dayjs().startOf("year");
      data.startDate = dayjs(thisYear).format("YYYY-MM-DD");
      data.endDate = dayjs().endOf("year").format("YYYY-MM-DD");
      break;
    case "LastYear":
      const lastYear = dayjs().startOf("year");
      data.startDate = dayjs(lastYear).add(-1, "year").format("YYYY-MM-DD");
      data.endDate = dayjs(lastYear).add(-1, "day").format("YYYY-MM-DD");
      break;

    default:
      break;
  }
  return data;
};

function convortDateStingToDateTime(datetime) {
  const [dateValues, timeValues] = datetime.split(" ");
  const [month, day, year] = dateValues.split("-");
  const [hours, minutes, seconds] = timeValues.split(":");
  const date = new Date(year, month - 1, day, hours, minutes, seconds);
  return date;
}

const GetDashboardCardApiCall = (setData, options) => {
  APICall(`/getDasboardCounters?${options}`).then((response) => {
    if (response.length > 0) {
      setData(response[0]);
    }
  });
};

const ColorCodeGeneretor = () => {
  return "#" + Math.random().toString(16).substr(2, 6);
};

export default CommanApiGETFunction;
export {
  GetSatartAndEndDate,
  convortDateStingToDateTime,
  GetDashboardCardApiCall,
  ColorCodeGeneretor,
  TableCellAmountFormate,
};
